(() => {
  const start = () => {
    const host = document.querySelector('.main-product-section');
    if (!host || host.dataset.xmasReady) return;
    host.dataset.xmasReady = 'true';
    const data = JSON.parse(document.querySelector('#xmas-product-data').textContent);
    const config = document.querySelector('#xmas-config');
    const form = document.querySelector('#xmas-product-form');
    const variants = data.variants || [];
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:config.dataset.currency || 'USD'}).format(value / 100);
    const slides = [...host.querySelectorAll('.product__media-list>.product__media-item')];
    const thumbs = [...host.querySelectorAll('.thumbnail-list .thumbnail')];
    const dots = [...host.querySelectorAll('.slider__dots button')];
    let current = 0;
    const gallery = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide,i) => { slide.classList.toggle('is-active',i===current); slide.setAttribute('aria-hidden', String(i!==current)); });
      thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i===current)));
      dots.forEach((dot,i) => {dot.classList.toggle('is-active',i===current);dot.setAttribute('aria-current',String(i===current));});
      const active = thumbs[current];
      if (active) active.parentElement.parentElement.scrollLeft = active.parentElement.offsetLeft - 30;
    };
    thumbs.forEach((thumb,i) => thumb.addEventListener('click',() => gallery(i)));
    dots.forEach((dot,i) => dot.addEventListener('click',() => gallery(i)));
    host.querySelectorAll('media-gallery button[name]').forEach(button => button.addEventListener('click',() => gallery(current+(button.name==='next'?1:-1))));
    const list = host.querySelector('.product__media-list');
    let touchStart;
    list.addEventListener('touchstart',e => touchStart=e.changedTouches[0].clientX,{passive:true});
    list.addEventListener('touchend',e => {const distance=e.changedTouches[0].clientX-touchStart;if(Math.abs(distance)>45)gallery(current+(distance<0?1:-1));},{passive:true});
    gallery(0);
    const radios = [...host.querySelectorAll('variant-selects input[type=radio]')];
    const stickySelect = host.querySelector('.sticky-atc__variant-select');
    const imageIndices = {'Memorial Angel':0,'Reindeer':8,'Angel':7,'Cardinal':6};
    const choose = (name,changeImage=true) => {
      const variant = variants.find(v=>v.title===name || v.option1===name);
      radios.forEach(r=>r.checked=r.value===name);
      if (stickySelect) stickySelect.value=name;
      const label = host.querySelector('[id^=custom-label]');
      if(label)label.textContent='style - '+name;
      if(changeImage)gallery(imageIndices[name] || 0);
      const input=form.querySelector('[name=id]');
      input.value=variant?.id || '';
      const price=variant?.price ?? 3999;
      host.querySelectorAll('.price-item--sale,.price__regular .price-item').forEach(e=>e.textContent=money(price));
      host.querySelectorAll('.quantity-break').forEach((offer,i)=>{
        const n=i+1, factor=[1,.9,.85,.8][i];
        const val=offer.querySelector('.quantity-break__price strong');
        if(val)val.textContent=money(Math.round(price*n*factor));
        const compare=offer.querySelector('.quantity-break__compare-price');
        if(compare)compare.textContent=n===1?'':money(price*n);
      });
      host.querySelectorAll('.main-product-atc').forEach(b=>b.disabled=!variant || !variant.available);
      if(variant){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
    };
    radios.forEach(r=>r.addEventListener('change',()=>choose(r.value)));
    stickySelect?.addEventListener('change',()=>choose(stickySelect.value));
    const initial=variants.find(v=>String(v.id)===new URLSearchParams(location.search).get('variant')) || variants[0];
    choose(initial?.title || 'Memorial Angel',new URLSearchParams(location.search).has('variant'));
    host.querySelector('.lct-button')?.addEventListener('click',()=>host.querySelector('.product__info-container').scrollIntoView({behavior:'smooth',block:'start'}));
    const syncQuantity=()=>{
      const quantity=Number(host.querySelector('input[name=quantity]:checked')?.value || 1);
      const discounted=quantity>1 && Boolean(config.getAttribute('data-code-'+quantity));
      const accelerated=form.querySelector('.shopify-payment-button');
      if(accelerated)accelerated.hidden=discounted;
      const buyNow=form.querySelector('#xmas-buy-now');
      if(buyNow)buyNow.hidden=!discounted;
    };
    host.querySelectorAll('input[name=quantity]').forEach(input=>input.addEventListener('change',syncQuantity));
    syncQuantity();
    form.addEventListener('submit',async event=>{
      const quantity=Number(host.querySelector('input[name=quantity]:checked')?.value || 1);
      const code=config.getAttribute('data-code-'+quantity);
      if(!code) return;
      event.preventDefault();
      const buttons=[...host.querySelectorAll('.main-product-atc')];
      buttons.forEach(b=>b.disabled=true);
      const error=host.querySelector('.product-form__error-message-wrapper');
      if(error)error.hidden=true;
      try{
        const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:form.querySelector('[name=id]').value,quantity}]})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description || result.message);
        const destination=event.submitter?.id==='xmas-buy-now'?'/checkout':(config.dataset.cartUrl || '/cart');
        location.href='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(destination);
      }catch(e){if(error){error.hidden=false;error.querySelector('.product-form__error-message').textContent=e.message;}buttons.forEach(b=>b.disabled=false);}
    });
    host.querySelectorAll('[data-dynamic-date=true]').forEach(e=>{
      const date=days=>{const d=new Date();d.setDate(d.getDate()+Number(days));return d.toLocaleDateString('en-US',{month:'short',day:'numeric'});};
      const text=e.dataset.text.replace('[start_date]',date(e.dataset.minDays)).replace('[end_date]',date(e.dataset.maxDays));
      e.innerHTML=text;
    });
    const sticky=host.querySelector('sticky-atc');
    const button=host.querySelector('.product-form__submit');
    if(sticky&&button)new IntersectionObserver(entries=>{sticky.classList.toggle('xmas-visible',!entries[0].isIntersecting && button.getBoundingClientRect().bottom<0);},{threshold:0}).observe(button);
    document.querySelectorAll('.menu-drawer__close-button,.modal__close-button').forEach(button=>button.addEventListener('click',()=>{const details=button.closest('details');if(details)details.open=false;}));
    document.querySelectorAll('header details').forEach(details=>details.addEventListener('toggle',()=>details.querySelector('summary')?.setAttribute('aria-expanded',String(details.open))));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('header details[open]').forEach(d=>d.open=false);});
    const backTop=document.querySelector('.scroll-to-top-btn');
    if(backTop){
      backTop.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));
      const update=()=>{backTop.style.display=window.scrollY>400?'':'none';};
      window.addEventListener('scroll',update,{passive:true});update();
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
